module.exports = __webpack_public_path__ + "static/img/logo.305d335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/header/logo.png
// module id = 7+0T
// module chunks = 1